<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">
                    <h2 class="mb-4">
                        Saul
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that those who love God will listen to, trust and obey his word wholeheartedly.
                        </li>
                        <li>
                            To understand that we reject God when we desire to be like the world instead of seeking his will.
                        </li>
                        <li>
                            To understand that God will judge repeated and deliberate disobedience.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series examines Saul’s brief kingship and his many failures to rule as God’s king.
                        Each lesson explores what it looks like to reject God as our ultimate king through two groups of people:
                    </p>

                    <ul>
                        <li>
                            Israel – did not trust in God’s provision and desired to be like the world instead (week 1).
                            They preferred a sinful, weak and greedy human king to their faithful and powerful God!
                        </li>
                        <li>
                            Saul – repeatedly ignored God’s word spoken through his prophet, Samuel (weeks 2, 3 and 4);
                            he doubted God’s power to change and equip him, trusting instead in his own qualifications (weeks 2 and 3);
                            and when confronted with his sin he made excuses and tried to hide (weeks 3 and 4).
                        </li>
                    </ul>

                    <p>
                        Israel’s and Saul’s mistakes are a warning and a lesson to those who love God to live differently.
                        Instead of rejecting God’s rule as they did we must submit to his kingship.
                        We do this by obeying his word wholeheartedly and completely, trusting his provision
                        and putting his will before our own sinful desires.
                        Ultimately this means submitting to God’s perfect chosen king, Jesus, who will never
                        fail as Saul did and whose reign will endure forever.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - A Human King (1 Samuel 8:1-22)
                    </p>
                    <p>
                        Lesson 2 - A Reluctant King (1 Samuel 9:1 - 10:27)
                    </p>
                    <p>
                        Lesson 3 - A Disobedient King (1 Samuel 13:1 - 14:45)
                    </p>
                    <p>
                        Lesson 4 - A Rejected King (1 Samuel 15:1-35)
                    </p>
                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Saul",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Saul`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that those who love God will listen to, trust and obey his word wholeheartedly.",
                },
            ],
        };
    },
};
</script>
